(function ($, Drupal, drupalSettings, once) {

  'use strict';

  function _get_month() {
    var month = [];
    month[0] = 'January';
    month[1] = 'February';
    month[2] = 'March';
    month[3] = 'April';
    month[4] = 'May';
    month[5] = 'June';
    month[6] = 'July';
    month[7] = 'August';
    month[8] = 'September';
    month[9] = 'October';
    month[10] = 'November';
    month[11] = 'December';
    var d = new Date();
    return month[d.getMonth()];
  }

  Drupal.behaviors.prefooteranalytics = {
    attach: function () {

      var PreFooterAdSeen = false;
      var journalAdsText = 'journal ads';
      var asset = $('.view-pre-footer-ad .feature-wrapper').attr('href');
      var buyer = $('.view-pre-footer-ad .feature-wrapper').attr('data-ad-buyer');


      function elementInView(elem) {
        return ($(window).scrollTop() + window.innerHeight) > $(elem).offset().top;
      }

      $(window).scroll(function () {
        if (elementInView($('.view-pre-footer-ad')) && !$('.path-frontpage').length) {
          if (buyer === '') {
            buyer = 'undefined';
          }
          if (PreFooterAdSeen === false) {
            PreFooterAdSeen = true;
            dataLayer.push({
              eventCategory: journalAdsText,
              eventAction: 'view',
              eventLabel: asset,
              event: 'eventClick',
              adBuyer: buyer,
              adMonth: _get_month()
            });
          }
        }
      });

      $(once('analytics', '.view-pre-footer-ad a')).click(function () {
        if (!$('.path-frontpage').length) {
          if (buyer === '') {
            buyer = 'undefined';
          }
          dataLayer.push({
            eventCategory: 'journal ads',
            eventAction: 'prefooter ad click',
            eventLabel: asset,
            event: 'eventClick',
            adBuyer: buyer,
            adMonth: _get_month()
          });
        }
      });
    }
  };
})(jQuery, Drupal, drupalSettings, once); // eslint-disable-line no-undef
